export default {
  assignoperators: {
    title: "Призначення операторів для рознесення пачок",
    topRow: {
      userCode: "Оператор",
      worked: "працював",
      onPositions: "на посаді"
    },
    receipts: {
      modal: {
        title: "Інформація про пачці"
      },
      form: {
        summa: {
          title: "Сума"
        },
        datebank: {
          title: "Дата з банку"
        },
        quantity: {
          title: "Квитанцій"
        },
        countband: {
          title: "Бандероль"
        },
        reasonname: {
          title: "Причина повернення"
        }
      }
    },
    freePacksColumn: {
      headers: {
        freePacks: "Вільні пачки"
      }
    },
    assignedPacksColumn: {
      headers: {
        assignedPacks: "Пачки, закріплені за оператором"
      }
    },
    packsCountbandColumn: {
      headers: {
        packsCountband: "Бандеролі"
      }
    },
    packsQuantityColumn: {
      headers: {
        packsQuantity: "Квитанції"
      }
    },
    operatorForm: {
      userCode: {
        msg: "Пачки, закріплені за оператором"
      }
    },
    statusInfoPack: {
      pack: "Пачка",
      wasPosting: "була рознесена",
      title: "Успішно"
    },
    assignBtn: {
      confirm: {
        assignOperator: "Призначити оператора",
        toWorkWithPack: "для роботи з цією пачкою",
        title: "Призначення"
      }
    },
    unassignBtn: {
      confirm: {
        unassignOperator: "Звільнити оператора",
        fromWorkWithPack: "від роботи з цією пачкою",
        title: "Звільнення"
      }
    }
  }
};
